<template>
  <div style="padding:40px;">
    <v-row
      align="center"
    >
      <v-col 
        cols="12"
        style="background-color: white; margin:0;padding:0 !important;"
      >
        <v-data-table
          :headers="headers"
          :items="logs"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="ID"
          hide-default-footer
          :items-per-page="-1"
          class="elevation-0"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Logs</v-toolbar-title>
              <v-spacer/>
              <v-spacer/>
        <v-text-field
          outlined
          append-icon="mdi-magnify"
          :prepend-inner-icon="search !== '' ? 'mdi-close' : ''"
          hide-details
          dense
          style="margin-right:10px;"
          v-model="search"
          autofocus
          @click:append="handleGetData"
          @click:prepend-inner="handleClear"
          v-on:keyup.enter="handleGetData"
        />
              <v-spacer/>
              <v-btn @click="handleGetData">
                refrescar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.OriginalURL`]="{ item }">
            <url-info
              :url="item.OriginalURL"
              :environment="environment"
            />
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="background-color: #f9ddb1;max-width:100px;">
              <p style="word-break: break-all;">URL: {{item.OriginalURL}}</p>
              <url-info
                :url="item.OriginalURL"
                :environment="environment"
              />
              <br/>
              <br/>
              <p>CD: {{ item.CD }} </p>
              <p>IP: {{ item.IP }} </p>
              <p>Path: {{ item.Path }} </p>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <p style="marging:0;">Body: </p>
                  <pre>
                    <code>
                      {{ prepareCode(item.Body) }}
                    </code>
                  </pre>
                </v-flex>
                <v-flex xs12 md6>
                  <p style="marging:0;">Query: </p>
                  <pre>
                    <code>
                      {{ prepareCode(item.Query) }}
                    </code>
                  </pre>
                </v-flex>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      <pagination
        :startIndex="startIndex"
        :itemsPerPage="itemsPerPage"
        :onGetData="handleGetData"
        :locale="locale"
        :count="count"
        :onChangeItemsPerPage="handleChangeItemsPerPage"
      />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from 'axios'
import Pagination from './Pagination'
export default {
  components: {
    Pagination,
  },
  data: () => ({
    logs: [],
    expanded: [],
    method: null,
    search: null,
    startIndex: 0,
    itemsPerPage: 10,
    count: 0,
  }),
  computed: {
    locale () {
      return 'es'
    },
    token () {
      return localStorage.getItem('jwt')
    },
    apiURL () {
      return `${process.env.VUE_APP_ENV === 'production' ? 'https' : 'http'}://${process.env.VUE_APP_API_DVIEWCONNECT_URL}`
    },
    headers () {
      return [
        { text: 'Player', value: 'DeviceName' },
        { text: 'UserName', value: 'UserName' },
        { text: 'Network', value: 'Network' },
        { text: 'Tipo', value: 'Type' },
        { text: 'Info', value: 'Info' },
        { text: 'CD', value: 'CD' },
      ]
    },
  },
  watch: {
  },
  mounted () {
    this.handleGetData(0)
  },
  methods: {
    handleClear () {
      this.search = null
      this.handleGetData(0)
    },
    convertDate (v) {
      const options = { weekday: 'long', day: 'numeric', month: 'numeric', year: 'numeric' }
      const date = new Date(v).toLocaleDateString(this.locale, options)
      const time = new Date(v).toLocaleTimeString(this.locale)
      const today = new Date().toLocaleDateString(this.locale, options)
      const isToday = date === today ? true : false 
      return `${isToday ? 'Hoy ' : '' }${date} ${time}`
    },
    async handleGetData (v) {
      if (v >= 0) this.startIndex = v
      this.logs = []
      const filter = { 
        search: this.search && this.search.length > 0 ? this.search : null,
        startIndex: this.startIndex, 
        itemsPerPage: this.itemsPerPage, 
      }
      axios.put(`${this.apiURL}/v1/private/brightsign/logs/?token=${this.token}`, filter)
        .then (response => {
          this.count = response.data.count
          this.logs = response.data.data.map(item => {
            item.CD = this.convertDate(item.CD)
            return item
          })
        })
        .catch (error => {
          console.log(error)
        })
    },
    handleChangeItemsPerPage (v) {
      this.itemsPerPage = v
      this.handleGetData(0)
    },
    prepareCode (v) {
      try {
        return v ? JSON.parse(v) : {}
      } catch (error) {
        console.log(error)
        return {}
      }
    },
  },
}
</script>

